import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hideModal } from '../../store/reducers/ModalReducer'
import { RootState } from '../../store/store'
import CSS from './Modal.module.css'

interface ModalProps {
    height?: string
}
function Modal(props: ModalProps) {
    const state = useSelector((state: RootState) => state)
    const dispatch = useDispatch()

    return (
        <AnimatePresence>
            {state.ModalReducer.show && (
                <motion.div
                    initial={{
                        opacity: 0,
                    }}
                    animate={{
                        opacity: 1,
                    }}
                    transition={{
                        type: 'spring',
                        stiffness: 260,
                        damping: 20,
                    }}
                    exit={{
                        opacity: 0,
                    }}
                    className={CSS.container}
                    onClick={(e) => {
                        e.stopPropagation()
                        dispatch(hideModal())
                    }}
                >
                    <div className={CSS.container_body}>
                        <div
                            className={CSS.modal}
                            onClick={(e) => {
                                e.stopPropagation()
                                console.log('hurray')
                            }}
                            style={{
                                height: props.height ? props.height : '30vh',
                            }}
                        >
                            <AnimatePresence>
                                {state.ModalReducer.show && (
                                    <motion.div
                                        initial={{
                                            scale: 0,
                                            translateX: -10,
                                            translateY: -10,
                                        }}
                                        animate={{
                                            scale: 1,
                                            translateX: 0,
                                            translateY: 10,
                                        }}
                                        transition={{
                                            type: 'spring',
                                            stiffness: 260,
                                            damping: 20,
                                        }}
                                        exit={{
                                            scale: 0,
                                        }}
                                        className={CSS.modal_body}
                                    >
                                        {state.ModalReducer.content}
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default Modal
